/* eslint-disable complexity */
import { format } from 'date-fns';
import { Keys, locale } from 'src/i18n';
import { isDev, parseJSON } from 'src/workspace/utils';
import { evaluate } from '../configMappingFormItemsGenerator/formulaContext/evaluate';
import { evaluateValidation } from '../configMappingFormItemsGenerator/formulaContext/queries';
import { LOCATION_FIELD_TYPE } from '../constants';
import { FormulaValidation, Validation } from './types';

export function getMeetingDateTimeErrorMessage(maxDate: Date): string {
  const dateTime = format(maxDate, "MMMM d, yyyy 'at' h:mm a");

  return locale(Keys.PLAN_YOUR_MEETING_DATE_TIME_BEFORE, { dateTime });
}

export function shouldTreatLocationNullAsRequiredError(
  type: string | undefined,
  value: unknown,
): boolean {
  if (isDev()) return false;

  const parsedValue = parseJSON(
    typeof value === 'string' ? value.trim() : value,
  );

  return type === LOCATION_FIELD_TYPE && parsedValue === null;
}

export function checkErrors(
  value,
  validations: Validation[] | FormulaValidation[],
  label: string,
  required: boolean,
): string[] {
  const errors: string[] = [];
  if (required && !value?.toString()?.trim()) {
    errors.push(locale(Keys.REQUIRED));
  }
  validations.forEach((validation) => {
    if (validation.expression) {
      const errorMsg = evaluateValidation(validation, evaluate);
      if (errorMsg) {
        errors.push(errorMsg);
      }
    } else if (
      value &&
      ((validation.validate && !validation.validate(value)) ||
        (validation.regex && !validation.regex.test(value)))
    ) {
      errors.push(validation.errorMessage);
    }
  });
  return errors;
}

export const ignoredRequiredTypes = ['label'];
